var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.mainConfig.sharesInSidebar)?_c('SocialShareIcons',{attrs:{"lot":_vm.lot}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }